import React from 'react';
import DOMPurify from 'dompurify';
export const HtmlSanitize = props => {
    const { html, sanitize } = props;
    const sanitized = React.useMemo(() => DOMPurify.sanitize(html, Object.assign(Object.assign({ ADD_ATTR: ['target'] }, sanitize), { RETURN_DOM_FRAGMENT: false, RETURN_DOM: false })), [html]);
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: sanitized } });
};
export const TextComponent = props => {
    const { text, html, sanitize } = props;
    return (React.createElement(React.Fragment, null, text &&
        (html ? (React.createElement(React.Fragment, null,
            React.createElement(HtmlSanitize, { html: text, sanitize: sanitize }))) : (React.createElement(React.Fragment, null, text)))));
};
